export default {
    googleToken: '',
    user: {},
    userId: '',
    unauthenticatedCount: 0,
};
